import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {UtilService} from '../../services/util.service';
import {ValidationConstraint} from '../../domain/validation-constraint';
import * as _ from 'lodash';

@Component({
    selector: 'app-custom-radio-group',
    templateUrl: './custom-radio-group.component.html',
    styleUrls: ['./custom-radio-group.component.scss']
})
export class CustomRadioGroupComponent implements OnInit, OnChanges {
    @Input() label: string;
    @Input() labelClass: string;
    @Input() result: any;
    @Input() value: string;
    @Input() display: string;
    @Input() required: boolean;
    @Input() groupClass: string;
    @Input() elementClass: string;
    @Input() options: any[];
    @Input() disabled: boolean;
    @Input() color: any;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() name: string;
    @Input() tooltips: any[];

    @Input() validationConstraints: ValidationConstraint[];

    @Output() resultChange = new EventEmitter();
    @Output() change = new EventEmitter();
    @ViewChild('control', { static: true }) control: ElementRef;
    @ViewChild('frm', { static: true }) form: any;

    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.value = this.value || 'value';
        this.display = this.display || 'display';
        this.color = this.color || 'primary';
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        this.updataValidationConstraints();
        this.name = this.name || 'control';
    }

    getValue(option: any, path: string) {
        let val = option;
        if (path !== '') {
            const dp = path.split('.');
            for (let i = 0; i < dp.length; i++) {
                val = val[dp[i]];
            }
        }
        return val;
    }

    setValue(event) {
        this.cd.markForCheck();
        this.resultChange.emit(event);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.result) {
            this.cd.markForCheck();
        }
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }
        if (changes.validationConstraints) {
            this.updataValidationConstraints();
        }
    }

    private updataValidationConstraints() {
        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
        }
    }

    onChange() {
        this.change.emit();
    }
}
